var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDayChooserNextDisabled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.560547 4.29639C0.560547 2.08725 2.35141 0.296387 4.56055 0.296387H20.5605C22.7697 0.296387 24.5605 2.08725 24.5605 4.29639V20.2964C24.5605 22.5055 22.7697 24.2964 20.5605 24.2964H4.56055C2.35141 24.2964 0.560547 22.5055 0.560547 20.2964V4.29639Z",
    fill: "#EEF1F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.56055 12.2964H18.5605M18.5605 12.2964L12.5605 6.29639M18.5605 12.2964L12.5605 18.2964",
    stroke: "#6F85FF",
    strokeOpacity: 0.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDayChooserNextDisabled);
export default __webpack_public_path__ + "res/media/day-chooser-next-disabled.1c4ccf53778e5566e393dcead3bf499c.svg";
export { ForwardRef as ReactComponent };